import { createFileRoute } from '@tanstack/react-router';
import { LeavePolicyPage } from '@/features/leave/leave-policy-page';
import { guardRoute } from '@/lib/route-guards';

export const Route = createFileRoute('/_app/hr/leave-policy')({
  beforeLoad: ({ context }) => {
    guardRoute(context.auth, '/hr/leave-policy');
  },
  component: LeavePolicyPage,
});
